<template>
  <footer id="page-footer" class="page-footer" role="contentinfo">
    <section class="page-footer-section">
      <!-- logo -->
      <div class="page-footer-logo">
        <!-- <img
          v-if="$i18n.locale === 'fr_CA'"
          src="~img/logo-dragonpass-fr.svg"
          alt="contentinfo image"
        />
        <img v-else src="~img/logo-dragonpass.svg" alt="contentinfo image" /> -->
        <img src="~img/new-logo-dragonpass-white.svg" alt="contentinfo image" />
      </div>
      <!-- footer-list -->
      <div class="page-footer-list">
        <div class="consult" v-if="!isFromPortal">
          <button role="button" @click="goToDoc('terms')">
            {{ $t('program-Terms-and-Conditions') }}
          </button>
          <button role="button" @click="goToDoc('termsofuse')">
            {{ $t('program-Term-Of-Use') }}
          </button>
          <button role="button" @click="goToDoc('termsofservice')">
            {{ $t('program-Terms-of-Service') }}
          </button>
          <button role="button" @click="goToDoc('privacypolicy')">
            {{ $t('Privacy-Policy') }}
          </button>
          <button role="button" @click="goToDoc('visa-notice')">
            {{ $t('footer-notice') }}
          </button>
          <button role="button" @click="goToFAQ">{{ $t('faqs') }} & {{ $t('contact') }}</button>
          <button role="button" @click="goToDoc('about')">{{ $t('program-About') }}</button>
        </div>
        <div v-if="!isFromPortal">
          <div class="app-address" v-if="$i18n.locale === 'en_US'">
            <img class="appstore" src="~img/appstore.svg" alt="image" @click="clickApple" />
            <img class="googleplay" src="~img/googleplay.svg" alt="image" @click="clickAndroid" />
          </div>
          <div class="app-address" v-else>
            <img class="appstore" src="~img/appstore3.svg" alt="image" @click="clickApple" />
            <img class="googleplay" src="~img/googleplay3.svg" alt="image" @click="clickAndroid" />
          </div>
        </div>
        <div class="copyright" role="copyright">
          <span v-if="!isFromPortal"> {{ $t('all-rights') }}<br />{{ $t('all-rights-2') }} </span>
          <span v-else> {{ $t('all-rights') }} All Rights Reserved </span>
        </div>
      </div>
    </section>
  </footer>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    name: 'page-footer',
    computed: {
      ...mapState(['isFromPortal']),
    },
    methods: {
      clickApple() {
        window.open('https://apps.apple.com/gb/app/visa-airport-companion/id1291608009');
      },
      clickAndroid() {
        window.open('https://play.google.com/store/apps/details?id=com.dragonpass.en.latam');
      },
      goToFAQ() {
        // 获取当前路由
        const currentRoute = this.$route.path;
        if (currentRoute === '/dining/details') {
          // 如果当前路由是 dining/details, 则增加fs埋点数据
          !!window.FS && FS.event('Dining_FAQs', {
            timestamp: new Date().getTime(),
            diningCode: this.$route.query.diningCode,
            diningID: this.$route.query.diningId,
          });
        }
        this.$router.push('/faqs');
      },
      goToDoc(path) {
        const currentRoute = this.$route.path;
        if (
          currentRoute === '/dining/details' &&
          (path === 'terms' || path === 'termsofuse' || path === 'termsofservice')
        ) {
          !!window.FS && FS.event('Dining_Terms', {
            timestamp: new Date().getTime(),
            diningCode: this.$route.query.diningCode,
            diningID: this.$route.query.diningId,
          });
        }
        if (path === 'visa-notice') {
          const link =
            this.$i18n.locale === 'fr_CA'
              ? 'https://www.visa.ca/fr_CA/legal/global-privacy-notice.html'
              : 'https://www.visa.ca/en_CA/legal/global-privacy-notice.html';
          window.open(link);
          return;
        }
        this.$router.push(`/${path}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'index.scss';
  @import './mobile.scss';
</style>
